export const rules = {
  validation: {
    email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    phoneNumber: /^[0-9]+$/, // /^[0-9]{10}$/
    name: /^[a-zA-Z ]*$/,
    number: /^(?=.*[0-9])[- +()0-9]+$/,
    password: /^.{6,}$/,
    zipCode: /^[a-zA-Z0-9_]+$/,
    address: /[^A-Za-z0-9\s_,./\\#&`~-]*$/g,
  },
};
